import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useUIStore = create(
  persist(
    (set, get) => ({
      sidebarCollapsed: false,
      toggleSidebar: () => set({ sidebarCollapsed: !get().sidebarCollapsed }),

      mobileSidebarOpen: false,
      openMobileSidebar: () => set({ mobileSidebarOpen: true }),
      closeMobileSidebar: () => set({ mobileSidebarOpen: false }),

      collapsedSections: {},
      toggleSection: (id) =>
        set({ collapsedSections: { ...get().collapsedSections, [id]: !get().collapsedSections[id] } }),
    }),
    { name: "lead-ui" }
  )
);
